import { handleAuthFlush } from "@/helpers/websockets/authentication/handlers";

export const FLUSH_AUTH_EVENT = "PermissionsFlushed" as const;

export const AUTH_EVENT_HANDLERS = {
  [FLUSH_AUTH_EVENT]: handleAuthFlush
};
